import { render, staticRenderFns } from "./SoftwareTable.vue?vue&type=template&id=b0c14c9a&"
import script from "./SoftwareTable.vue?vue&type=script&lang=js&"
export * from "./SoftwareTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports